export const COMPANY = {
  name: "Green Volt LTD",
  brn: "C24205569",
  whatsapp: "23057065110",
  whatsappDisplay: "+230 5706 5110",
  email: "sales.greenvolt@gmail.com",
  location: "Mauritius",
};

export function whatsappUrl(message: string) {
  return `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(message)}`;
}

export function mailtoUrl(subject: string, body: string) {
  return `mailto:${COMPANY.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
